export default __webpack_public_path__ + "static/media/outer-timer.d635cafc.svg";